(function() {
  const attributes = {
    email: 'data-klaviyo-newsletter-email',
    submit: 'data-klaviyo-newsletter-submit',
    message: 'data-klaviyo-newsletter-message',
    form: 'data-klaviyo-newsletter-form',
  };

  class KlaviyoNewsletter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector(`[${attributes.form}]`);
      this.emailInput = this.querySelector(`[${attributes.email}]`);
      this.submitButton = this.querySelector(`[${attributes.submit}]`);
      this.messageElement = this.querySelector(`[${attributes.message}]`);

      this.listId = this.getAttribute('list-id');
      this.publicApiKey = this.getAttribute('public-api-key');

      if (!this.form) return;
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    async handleSubmit(event) {
      event.preventDefault();

      const email = this.emailInput?.value?.trim();
      if (!email) {
        this.showMessage('Please enter a valid email address.', 'error');
        return;
      }

      this.setLoading(true);

      try {
        const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.publicApiKey}`;

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'revision': '2024-10-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                    },
                  },
                },
                custom_source: 'Footer Newsletter',
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: this.listId,
                  },
                },
              },
            },
          }),
        });

        if (response.ok || response.status === 202) {
          this.showMessage('Thank you for subscribing!', 'success');
          this.emailInput.value = '';
          this.setAttribute('submitted', '');
        } else {
          const errorData = await response.json().catch(() => null);
          const errorMessage = errorData?.errors?.[0]?.detail || 'Subscription failed. Please try again.';
          this.showMessage(errorMessage, 'error');
        }
      } catch (error) {
        console.error('Klaviyo subscription error:', error);
        this.showMessage('An error occurred. Please try again later.', 'error');
      } finally {
        this.setLoading(false);
      }
    }

    showMessage(message, type) {
      if (this.messageElement) {
        this.messageElement.textContent = message;
        this.messageElement.hidden = false;
        this.messageElement.classList.remove('success', 'error');
        this.messageElement.classList.add(type);
      }
    }

    setLoading(isLoading) {
      if (isLoading) {
        this.setAttribute('loading', '');
        if (this.submitButton) this.submitButton.disabled = true;
      } else {
        this.removeAttribute('loading');
        if (this.submitButton) this.submitButton.disabled = false;
      }
    }
  }

  if (!customElements.get('klaviyo-newsletter')) {
    customElements.define('klaviyo-newsletter', KlaviyoNewsletter);
  }
})();
